import { postWithToken } from '~/code/services'
import { ConfigStore } from '~/code/config'
import { CardScheme } from '~/code/pages/CardData/models'

export function fetchCardScheme (packet: string) {
    return postWithToken<CardScheme>(`${ ConfigStore.getUrl().apiUrl }/transaction/iinLookup`, { packet })
}
